import { render, staticRenderFns } from "./SaleListTab.vue?vue&type=template&id=d6febf1c&"
import script from "./SaleListTab.vue?vue&type=script&lang=js&"
export * from "./SaleListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports